<template>
  <div>
    <custom-callout
      class="mt-3 custom-callout"
      :opened="isOpen"
      :controlled="true"
      @click:open="onToggle()"
    >
      <div class="row border-bottom py-3 pb-4 m-0">
        <div class="col-md-5 col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Equipo:
          </div>
          <div class="color-black font-16 font-weight-bold">
            {{ item.equipmentName | empty }}
          </div>
        </div>
        <div class="col-md col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Clasificación de Cumplimiento:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.classification?.name | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12" v-if="!isSifdePurchaseMethod">
          <drop-down
            :always-show-dropdown="false"
            :items="actionItems"
            class="float-md-right mr-5"
          />
        </div>
      </div>
      <div class="row py-3 pt-4 m-0">
        <div class="col-md-5 col-12">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Requiere ser adquirido por el CAAT, por no estar disponibles en la
            escuela:
          </div>
          <div class="color-black font-16 font-weight-normal">
            Si
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Método de Compra:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ getPurchaseMethod | empty }}
          </div>
        </div>
      </div>
      <template #edition>
        <div class="bg-light-gray p-3" v-if="showAdditionalInfo">
          <div class="px-4 py-3 bg-white rounded" v-if="isSifdePurchaseMethod">
            <div class="d-flex align-items-center mb-3">
              <i class="fas fa-info-circle mr-2 text-orange"></i>
              <div class="color-gray-7 font-16 font-weight-bold">
                Información de Solicitud SIFDE
              </div>
            </div>
            <div class="">
              <div class="row">
                <div class="col-md-3 col-12">
                  <div class="color-secondary-6 font-14 mr-2">
                    Razón:
                  </div>
                  <div class="color-black font-16 ">
                    {{ sifdeRequestInfo?.reasonName | empty }}
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="color-secondary-6 font-14 mr-2">
                    Fecha de solicitud:
                  </div>
                  <div class="color-black font-16">
                    {{ sifdeRequestInfo?.createdDate | date }}
                  </div>
                </div>
                <div class="col-12 mt-md-3">
                  <div class="color-secondary-6 font-14 mr-2">
                    Comentario:
                  </div>
                  <div class="color-black font-16">
                    {{ sifdeRequestInfo?.comment | empty }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <custom-tab v-else nav-class="nav-vue-underline" no-nav-style>
            <custom-tab-item title="Descripción del Equipo">
              <div class="p-4">
                {{ item.description }}
              </div>
            </custom-tab-item>
          </custom-tab>
        </div>
        <div v-if="showAssignedEquipment" class="py-4 px-2 bg-light-gray">
          <div class="px-4 py-1">
            <div class="mb-3 font-weight-bold">
              <i class="fas fa-file-user text-orange mr-2"></i>
              Equipo Seleccionado en Inventario
            </div>
          </div>
          <div class="px-4">
            <result-row
              class="custom-row-bg"
              :from-acquisition="true"
              :inventory-flow="true"
              :editable="inventoryEditable"
              :item="item.equipment"
              :recommendation="recommendation"
              :referral="referral"
              @open="handlerOpen"
              @close="handlerClose"
              @refresh="refreshPage"
            />
          </div>
        </div>
      </template>
    </custom-callout>
    <div v-if="!isValid">
      <div
        class="requistion-row alert alert-danger border-top-0 rounded-bottom"
        role="alert"
      >
        <i class="fas fa-times-circle icon-sand-animate fa-lg mr-3"></i>
        <span class="text-danger">
          Necesita completar la documentación del método de compra.
        </span>
      </div>
    </div>
    <div v-if="hasPendingTransferRequest">
      <div
        class="requistion-row alert alert-danger border-top-0 rounded-bottom"
        role="alert"
      >
        <i class="fas fa-times-circle icon-sand-animate fa-lg mr-3"></i>
        <span class="text-danger">
          El equipo cuenta con una solicitud de transferencia en proceso.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import mixAlert from '@/mixins/alert.mixin';
import ResultRow from '@/views/inventory/equipmentMaintenance/inventoryManagement/components/ResultRow';
import purchaseMethod from '@/utils/constants/purchaseMethods';
import referralService from '@/services/api/referralsandequipments.api';
import peiATServiceStatus from '@/utils/constants/peiATServiceStatus';

const AVAILABILITY_MANAGEMENT = 'AvailabilityManagement';

const TEMPLATE_TAB_INDEX = {
  AdditionalInfo: 0,
  AssignedEquipment: 1,
};

export default {
  name: 'RequisitionAnalysisEquipmentRow',
  components: {
    CustomCallout,
    CustomTab,
    CustomTabItem,
    DropDown,
    ResultRow,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
    referral: {
      type: Object,
      required: false,
      default: () => null,
    },
    classifications: {
      type: Array,
      required: true,
    },
    purchaseMethods: {
      type: Array,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Boolean,
      default: false,
    },
    peiAtServiceId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selectedTemplateTabIndex: TEMPLATE_TAB_INDEX.AdditionalInfo,
      isOpen: false,
      sifdeRequestInfo: {},
    };
  },
  computed: {
    recommendation() {
      return {
        equipmentId: this.item?.equipment?.id,
        serviceStatusId: this.referral?.serviceStatusId,
        id: this.item?.recommendationId,
      };
    },
    inventoryEditable() {
      return (
        this.referral?.serviceStatusId ==
        peiATServiceStatus.PendienteAnalisisRequisicion
      );
    },
    hasEquipment() {
      return !!this.item.equipment;
    },
    isValid() {
      return this.validate ? this.item.purchaseMethod != null : true;
    },
    hasPendingTransferRequest() {
      return this.validate
        ? this.item.equipment?.hasPendingTransferRequest
        : false;
    },
    actionItems() {
      let items = [
        {
          name: 'Ver Inventario',
          icon: 'far fa-file-export text-green',
          click: async () => {
            this.goToInventory();
          },
        },
      ];

      if (this.hasEquipment) {
        items = [
          {
            name: 'Descripción de Equipo',
            icon: 'fas fa-info-circle text-green',
            click: async () => {
              this.setTab(TEMPLATE_TAB_INDEX.AdditionalInfo);
            },
          },
          ...items,
          {
            name: 'Ver Equipo Seleccionado',
            icon: 'far fa-file-user text-green',
            click: async () => {
              this.setTab(TEMPLATE_TAB_INDEX.AssignedEquipment);
            },
          },
        ];
      }

      return items;
    },
    showAdditionalInfo() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.AdditionalInfo;
    },
    showAssignedEquipment() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.AssignedEquipment
      );
    },
    isSifdePurchaseMethod() {
      return this.item.purchaseMethod?.id === purchaseMethod.SIFDE;
    },
    getPurchaseMethod() {
      return this.item.purchaseMethod
        ? this.item.purchaseMethod.name
        : 'Inventario';
    },
  },
  methods: {
    async getSifdeRequestInfo() {
      const { data } = await referralService.getSifdeRequestInfo(
        this.item.recommendationId
      );
      this.sifdeRequestInfo = data;
    },
    goToInventory() {
      this.$router.push({
        name: AVAILABILITY_MANAGEMENT,
        params: {
          id: this.peiAtServiceId,
          recommendationId: this.item.recommendationId,
        },
      });
    },
    setTab(id) {
      this.selectedTemplateTabIndex = id;
      this.isOpen = true;
    },
    async onToggle() {
      if (this.isOpen) {
        this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.AdditionalInfo;
      } else if (this.isSifdePurchaseMethod) {
        this.getSifdeRequestInfo();
      }
      this.isOpen = !this.isOpen;
    },
    handlerOpen(item) {
      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
      this.$emit('refresh');
    },
    refreshPage() {
      this.selectedTemplateTabIndex = null;
      this.isOpen = false;
      this.$emit('refresh');
    },
  },
};
</script>
<style lang="scss">
.alert {
  padding: 0.75rem 0.55rem;
}
</style>
